<template>
  <ResponsiveModal
    :open="true"
    :variant="'default'"
    background="white"
    :showFooter="false"
    @update:open="$emit('update:open', $event)"
  >
    <template #header>
      <Component
        ref="header"
        :is="DrawerHeader"
        :title="$t('components.scan_qr.title')"
        class="max-md:border-b max-md:rounded-none"
      />
    </template>
    <template #content>
      <div class="flex flex-col grow md:h-full h-screen">
        <qrcode-stream @decode="handleDecode"></qrcode-stream>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { DrawerHeader } from "@/SharedComponents/Drawer";

import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { validate as isUuid4 } from "uuid";
import axios from "axios";

const emit = defineEmits(["close", "decode", "update:open"]);

const props = defineProps({
  space: {
    type: String,
    required: false,
  },
});

async function handleDecode(url) {
  let id = url.split("/").pop();
  emit("decode", id);

  if (props.space) {
    // If something other than a UUID is decoded, we assume a QR code
    // with a shortened URL was scanned.
    if (!isUuid4(id)) {
      const {
        data: { url },
      } = await axios.get(route("s.resolve", id));
      id = url.split("/").pop();
    }

    router.put(
      route("qr_code.update", id),
      {
        space_id: props.space,
      },
      {
        onSuccess: () => close(),
      }
    );
  }
}
</script>
